import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const UIUXDesign = () => {
  return <PageTemplate title="UI/UX Design" subtitle="User-Centered Design Solutions" breadcrumb="Applications > UI/UX Design"><div className="content-section"><p>Professional UI/UX design services for web and mobile applications.</p></div></PageTemplate>;
};
export default UIUXDesign; 